/* Brand icons for popular RSS reader apps. Used in the import source picker.
   SVG paths sourced from Simple Icons (simpleicons.org) where available. */

import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

function iconBase(className?: string) {
  return cn("size-5 shrink-0", className);
}

export function FeedlyIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={iconBase(className)}>
      <path d="M3.37.002C1.507.002 0 1.508 0 3.37v17.26C0 22.493 1.507 24 3.37 24h17.26c1.863 0 3.37-1.507 3.37-3.37V3.37C24 1.508 22.493.002 20.63.002H3.37zm8.809 5.166l7.433 7.29-2.02 1.985-5.413-5.315-5.413 5.315-2.02-1.985 7.433-7.29zm-5.402 8.47l5.402 5.303 5.403-5.302-2.02-1.985-3.383 3.318-3.382-3.32-2.02 1.986z" />
    </svg>
  );
}

export function InoreaderIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={iconBase(className)}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.784 4.806c4.623 0 8.538 2.904 10.091 6.99l-2.238.826c-1.212-3.186-4.266-5.452-7.853-5.452V4.806zm0 4.126c2.944 0 5.449 1.852 6.435 4.457l-2.24.826c-.606-1.6-2.148-2.738-3.96-2.738l-.235.003V8.932zm-.198 4.283a2.984 2.984 0 110 5.968 2.984 2.984 0 010-5.968z" />
    </svg>
  );
}

export function ReederIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={iconBase(className)}>
      <path d="M12 1.5a1.5 1.5 0 011.5 1.5v6.379l4.94-4.94a1.5 1.5 0 012.12 2.122L15.622 11.5H22a1.5 1.5 0 010 3h-6.379l4.94 4.94a1.5 1.5 0 01-2.122 2.12L13.5 16.622V23a1.5 1.5 0 01-3 0v-6.379l-4.94 4.94a1.5 1.5 0 01-2.12-2.122L8.378 14.5H2a1.5 1.5 0 010-3h6.379L3.44 6.56a1.5 1.5 0 012.122-2.12L10.5 9.378V3A1.5 1.5 0 0112 1.5z" />
    </svg>
  );
}

export function NewsBlurIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={iconBase(className)}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-2.033 6h2.93l3.07 5.148V6h2.366v12h-2.7L12.4 12.546V18H10.05l-.083-5.545L6.667 18H4.033l5.934-12z" />
    </svg>
  );
}

export function NetNewsWireIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={iconBase(className)}>
      <path d="M3.5 2A3.5 3.5 0 000 5.5v13A3.5 3.5 0 003.5 22h17a3.5 3.5 0 003.5-3.5v-13A3.5 3.5 0 0020.5 2h-17zM5 7.5A1.5 1.5 0 116.5 9 1.5 1.5 0 015 7.5zm0 4.5a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zm0 4a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" />
    </svg>
  );
}
